import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DatepickerOptions } from 'ng2-datepicker';
import { PartnerService } from '../../../services/partner.service';
import { SubscriptionService } from '../../../services/subscription.service';
import { MasterdataService } from '../../../services/masterdata.service';
import { ToastService } from 'projects/app-core/src/app/services/toastr.service';
import { Status } from '../../../stores/types';
import {
  CompanyMetaAppliesTo,
  CompanyMetaConfigField,
  IAnyoPartner,
  IPartnerSsoDomain,
  ISpocDetails,
} from '../../../models/IPartner';
import { ISubscription } from '../../../models/ISubscription';
import { IAnyoError } from 'projects/app-core/src/models/errorModal';
import { AuthService } from 'projects/app-core/src/auth/auth.service';
import { lastValueFrom } from 'rxjs';
import {
  AnyoS3Buckets,
  FileUtilsService,
} from 'projects/app-core/src/service/fileService';
import { v4 as uuidv4 } from 'uuid';
import { UserTags } from 'projects/app-core/src/app/posts/model/CirclePost';
import * as moment from 'moment';
import { toCamelCaseKey } from '../../../utils/textUtils';
@Component({
  selector: 'app-add',
  templateUrl: './add.component.html',
  styleUrls: ['./add.component.scss'],
})
export class AddComponent {
  companyLogo: File | undefined;
  uploadCompanyLogo($event: any) {
    const file = $event.target.files[0];
    if (file) {
      this.companyLogo = file;
    }
  }
  gotonext: boolean = false;
  addCompanyForm!: FormGroup;
  steppertitle1: string = 'Partner Information';
  steppertitle2: string = 'Subsription';
  partnerId: string = '';
  subscriptionId: string = '';
  spocId: string = '';
  viewForm: boolean = false;
  isDisabled: boolean = false;
  isSpocDelete: boolean = false;
  editMode: boolean = false;
  isSubscription: boolean = false;
  isAlert: boolean = false;
  alertHeaderDisable: string = 'Partner Disable';
  alertBodyDisable: string =
    'Please make sure that you want to disable the partner';
  alertHeaderDelete: string = 'SPOC Delete';
  alertBodyDelete: string =
    'Please make sure that you want to permanently delete the SPOC';
  alertHeaderEnable: string = 'Partner Enable';
  alertBodyEnable: string =
    'Please make sure that you want to enable the partner';
  partnerSector: any[] = [];
  partnerType: any[] = [];
  noOfSubscriptions: any[] = [];
  showDisable: boolean = false;
  isSubmit: boolean = false;
  allowFamilyInvites = false;
  archived = false;
  showMaxFamilyInvitesAllowed = false;
  maxFamilyInvitesAllowed: number = 0;
  whitelistedDomains: { domain: string }[] = [];
  partnerDashboardId = '';
  partnerDashboardUrl = '';
  isDOB = false;
  isGender = false;
  isPhoneNumber = false;
  isName = false;
  isEmail = false;
  loading = false;
  isTesting = false;
  companyMetaAppliesTo = CompanyMetaAppliesTo;
  companyMetaConfigForms: Array<CompanyMetaConfigField & { optionsInput: string }> = [];
  ssoDomain = '';
  showRestrictReplyDisabledHint = false;
  ssoEnabled = false;
  ssoIdpEntityId = '';
  ssoLoginUrl = '';
  ssoCertificate = '';
  ssoSignRequest = false;
  ssoProviderId = '';
  ssoConfigName = '';
  ssoSpType: 'firebase' | 'anyobackend' = 'firebase';
  ssoIdpType: 'azure' | 'gsuite' = 'azure';
  ssoSaving = false;

  addDomain() {
    this.whitelistedDomains.push({ domain: '' });
  }

  removeDomain(i: number) {
    this.whitelistedDomains.splice(i, 1);
  }

  addCompanyMetaField() {
    this.companyMetaConfigForms.push({
      key: '',
      label: '',
      options: [],
      optionsInput: '',
      required: false,
      appliesTo: CompanyMetaAppliesTo.CORPORATE,
      order: this.companyMetaConfigForms.length,
      enabled: true,
    });
  }

  removeCompanyMetaField(index: number) {
    this.companyMetaConfigForms.splice(index, 1);
    this.companyMetaConfigForms = this.companyMetaConfigForms.map((field, idx) => ({
      ...field,
      order: idx,
    }));
  }

  constructor(
    private auth: AuthService,
    private router: Router,
    private partnerService: PartnerService,
    private subscriptionService: SubscriptionService,
    private masterdataService: MasterdataService,
    private toastService: ToastService,
    private activatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private fileService: FileUtilsService,
  ) {
    this.addCompanyForm = this.formBuilder.group({
      companyname: ['', Validators.required],
      companybranch: ['', Validators.required],
      partnertype: ['', Validators.required],
      weblink: ['', Validators.required],
      address: ['', Validators.required],
      city: ['', Validators.required],
      state: ['', Validators.required],
    });
  }

  spoc: any = [
    {
      name: '',
      email: '',
      mobile: '',
      isOperations: false,
    },
  ];

  partner: IAnyoPartner = {
    companyName: '',
    companyBranch: '',
    partnerType: '',
    companySector: '',
    websiteLink: '',
    address: '',
    city: '',
    state: '',
    year: '',
    totalStrength: 0,
    ownership: '',
    isListed: false,
    isProfitable: false,
    spocDetails: this.spoc,
    archived: false,
    companyLogoUrl: '',
    isTesting: false,
    allowMarketingEmailNotifications: true,
    restrictUserPostReplies: false,

    // status: "active",
  };

  subscription: ISubscription = {
    partnerId: '',
    noOfSubscriptions: 0,
    noOfTherapySessions: 0,
    planDuration: 0,
    subscriptionStart: '',
    subscriptionEnd: '',
    corporateSubscriptions: 0,
    familySubscriptions: 0,
  };

  options: DatepickerOptions = {
    inputClass: 'input small-text noborder',
    calendarClass: 'datepicker-default',
    format: 'dd/MM/yyyy',
    scrollBarColor: '#010001',
    placeholder: 'DD-MM-YYYY',
  };

  onInputChange(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    const inputValue = Number(inputElement.value);
    if (inputValue < 0) {
      inputElement.value = '';
    }
  }

  showMaxFamilyInvitesAllowedFn(value: boolean) {
    this.showMaxFamilyInvitesAllowed = value;
  }

  onShowMaxFamilyInvitesValidation(event: any) {
    const target = event.target as HTMLInputElement;
    let value: number | null = parseInt(target.value.trim());

    if (isNaN(value) || value < 0 || value > 5) {
      target.value = target.value.replace(/[^1-5]/g, '');
      value = parseInt(target.value);
    }

    target.value = target.value[0];

    this.maxFamilyInvitesAllowed = value as number;
  }

  onCorporateSubscription(event: any) {
    const corporateSubscriptions = parseInt(event.target.value);

    this.subscription.corporateSubscriptions = 0;
    this.subscription.familySubscriptions = 0;
    this.subscription.noOfSubscriptions = 0;

    if (!isNaN(corporateSubscriptions)) {
      this.subscription.corporateSubscriptions = corporateSubscriptions;

      if (this.partner.allowFamilyInvites) {
        const maxFamilyInvites = this.partner.maxFamilyInvitesAllowed || 0;
        this.subscription.familySubscriptions =
          maxFamilyInvites * corporateSubscriptions;
        this.subscription.noOfSubscriptions =
          corporateSubscriptions + this.subscription.familySubscriptions;
      } else {
        this.subscription.corporateSubscriptions = corporateSubscriptions;
        this.subscription.noOfSubscriptions = corporateSubscriptions;
      }
    }
  }

  async submit(form: any, moveNext?: boolean) {
    // Trim dashboard fields
    this.partnerDashboardId = (this.partnerDashboardId || '').trim();
    this.partnerDashboardUrl = (this.partnerDashboardUrl || '').trim();

    // Basic URL validation when provided
    if (this.partnerDashboardUrl) {
      if (!this.isValidUrl(this.partnerDashboardUrl)) {
        this.toastService.showError('Please enter a valid Partner Dashboard URL');
        this.isSubmit = true;
        return;
      }
    }

    // Validate compulsory fields before proceeding
    if (!this.validatePartnerRequired()) {
      this.isSubmit = true;
      this.toastService.showError('Please fill all the required fields');
      return;
    }
    if (this.whitelistedDomains.length) {
      this.partner.whitelistedDomains = this.whitelistedDomains.map(
        (data) => data.domain.trim().toLowerCase(),
      );
    } else {
      this.partner.whitelistedDomains = [];
    }
    this.partner.partnerPortalDashboardId = this.partnerDashboardId;
    this.partner.partnerPortalDashboardUrl = this.partnerDashboardUrl;
    this.partner.dataCollection = {
      phoneNumber: this.isPhoneNumber,
      dob: this.isDOB,
      name: this.isName,
      email: this.isEmail,
      gender: this.isGender,
    };
    this.partner.companyMetaConfig = this.companyMetaConfigForms
      .map((field, index) => ({
        key: toCamelCaseKey(field.key || ''),
        label: (field.label || '').trim(),
        options: (field.optionsInput || '')
          .split(',')
          .map((option) => option.trim())
          .filter((option) => !!option),
        required: !!field.required,
        appliesTo: field.appliesTo || CompanyMetaAppliesTo.CORPORATE,
        order: Number.isFinite(Number(field.order)) ? Number(field.order) : index,
        enabled: field.enabled !== false,
      }))
      .filter((field) => field.key && field.label && field.options.length > 0)
      .sort((a, b) => a.order - b.order);
    this.partner.allowFamilyInvites = this.allowFamilyInvites;
    this.partner.maxFamilyInvitesAllowed = this.maxFamilyInvitesAllowed! || 0;
    this.partner.archived = this.archived;
    this.partner.spocDetails.forEach((spoc: { email: string }) => {
      spoc.email = spoc.email.trim();
      // Also trim optional name and mobile if present
      (spoc as any).name = ((spoc as any).name || '').trim();
      (spoc as any).mobile = ((spoc as any).mobile || '').trim();
    });
    if (this.companyLogo) {
      const uuid = uuidv4();
      const uuidWithoutHyphens = uuid.replace(/-/g, '');
      const extension = this.companyLogo.name.split('.').pop();
      this.toastService.showSuccess('Uploading Company Logo');
      const filePath = `partners/company_logo_${uuidWithoutHyphens}.${extension}`;
      const uploadUrl = await lastValueFrom(
        this.fileService.generateUploadUrl(
          AnyoS3Buckets.CDN_BUCKET,
          filePath,
          this.companyLogo.type,
        ),
      );
      await lastValueFrom(
        this.fileService.uploadFile(this.companyLogo, uploadUrl.url),
      );
      this.toastService.showSuccess('Company Logo Uploaded');
      this.partner.companyLogoUrl = filePath;
    }
    const req = this.partner;
    if (this.editMode) {
        const _id = String(this.activatedRoute.snapshot.params['id']);
        this.loading = true;
        this.partnerService.updatePartner(_id, req).subscribe({
          next: () => {
            this.toastService.showSuccess('Partner Updated!');
            if (!this.gotonext) {
              this.router.navigate(['/partner']);
            }
            this.loading = false;
          },
          error: (error) => {
            this.gotonext = false;
            const errorBody = error.error as IAnyoError;
            this.toastService.showAnyoErrorToast(errorBody.description);
            this.loading = false;
          },
        });
    } else {
        this.loading = true;
        // console.log(moveNext);
        // setTimeout(() => {
        //     if (moveNext) {
        //       this.gotonext = true;
        //     }
        //         if (!this.gotonext) {
        //       this.router.navigate(['/partner']);
        //     }
        // this.loading = false;
        // },2000);
         
        this.partnerService.createPartner(req).subscribe({
          next: (value: any) => {
            this.partnerId = value.partnerId;
            if (moveNext) {
              this.gotonext = true;
            }
            if (!this.gotonext) {
              this.router.navigate(['/partner']);
            }
            this.loading = false;
          },
          error: (error) => {
            this.gotonext = false;
            const errorBody = error.error as IAnyoError;
            this.toastService.showAnyoErrorToast(errorBody.description);
            this.loading = false;
          },
        });
    }
  }

  // Validate compulsory partner fields
  private validatePartnerRequired(): boolean {
    const p = this.partner;
    const hasSpoc = Array.isArray(p.spocDetails) && p.spocDetails.length > 0;
    const primarySpoc = hasSpoc ? p.spocDetails[0] as any : undefined;

    const checks = [
      !!p.partnerType,
      !!p.companyName,
      !!p.companyBranch,
      !!p.websiteLink,
      !!p.address,
      !!p.city,
      !!p.state,
      !!primarySpoc && !!primarySpoc.name,
      !!primarySpoc && !!primarySpoc.email,
      !!primarySpoc && !!primarySpoc.mobile,
    ];
    return checks.every(Boolean);
  }

  // Simple URL validation helper
  private isValidUrl(url: string): boolean {
    try {
      const u = new URL(url);
      return !!u.protocol && !!u.host;
    } catch {
      return false;
    }
  }

  getWhitelistedDomainsForSso() {
    return this.whitelistedDomains
      .map((value) => value.domain?.trim().toLowerCase())
      .filter((value): value is string => Boolean(value));
  }

  private sanitizeClientCode(clientCode: string) {
    return clientCode
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9-]/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');
  }

  private hydrateSsoFormFromPartner(domain?: string) {
    const selectedDomain = (domain || this.ssoDomain || '').trim().toLowerCase();
    if (!selectedDomain) {
      return;
    }

    const existing = this.getSsoDomainEntry(selectedDomain);
    if (!existing) {
      this.ssoProviderId = '';
      this.ssoConfigName = '';
      this.ssoEnabled = false;
      this.ssoIdpType = 'azure';
      this.ssoIdpEntityId = '';
      this.ssoLoginUrl = '';
      this.ssoCertificate = '';
      this.ssoSignRequest = false;
      this.ssoSpType = 'firebase';
      return;
    }

    this.ssoDomain = existing.domain;
    this.ssoEnabled = existing.enabled;
    this.ssoSpType = existing.saml?.sp?.type || 'firebase';
    this.ssoProviderId = existing.saml?.sp?.providerId || '';
    this.ssoConfigName = existing.saml?.sp?.gipInboundSamlConfigName || '';
    this.ssoSignRequest = !!existing.saml?.sp?.signRequest;
    this.ssoIdpType = existing.saml?.idp?.type || 'azure';
    this.ssoIdpEntityId = existing.saml?.idp?.entityId || '';
    this.ssoLoginUrl = existing.saml?.idp?.ssoUrl || '';
    this.ssoCertificate = existing.saml?.idp?.x509Certificate || '';
  }

  onSsoDomainChange(domain: string) {
    this.ssoDomain = (domain || '').trim().toLowerCase();
    this.hydrateSsoFormFromPartner(this.ssoDomain);
  }

  onRestrictUserPostRepliesChange(enabled: boolean) {
    this.showRestrictReplyDisabledHint = !!this.partner.restrictUserPostReplies && !enabled;
    this.partner.restrictUserPostReplies = enabled;
  }

  saveSsoConfiguration() {
    const partnerMongoId = String(this.activatedRoute.snapshot.params['id'] || '');
    if (!partnerMongoId) {
      this.toastService.showError('Please save the partner first before configuring SSO');
      return;
    }

    const clientCode = this.sanitizeClientCode(this.partner.clientCode || '');
    if (!clientCode) {
      this.toastService.showError('Client code is required for SSO configuration');
      return;
    }

    const domain = (this.ssoDomain || '').trim().toLowerCase();
    if (!domain) {
      this.toastService.showError('Please select a domain for SSO configuration');
      return;
    }

    const allowedDomains = this.getWhitelistedDomainsForSso();
    if (!allowedDomains.includes(domain)) {
      this.toastService.showError('Selected domain must be in whitelisted domains');
      return;
    }

    if (!this.ssoIdpEntityId.trim() || !this.ssoLoginUrl.trim() || !this.ssoCertificate.trim()) {
      this.toastService.showError('Please fill IdP Entity ID, SSO URL and certificate');
      return;
    }

    this.ssoSaving = true;
    this.partner.clientCode = clientCode;

    this.partnerService.upsertPartnerClientCode(partnerMongoId, clientCode).subscribe({
      next: () => {
        this.partnerService
          .upsertPartnerSsoDomain(partnerMongoId, {
            domain,
            enabled: this.ssoEnabled,
            spType: this.ssoSpType,
            idpType: this.ssoIdpType,
            idp: {
              entityId: this.ssoIdpEntityId.trim(),
              ssoUrl: this.ssoLoginUrl.trim(),
              x509Certificate: this.ssoCertificate.trim(),
            },
            signRequest: this.ssoSignRequest,
          })
          .subscribe({
            next: (response: unknown) => {
              const data = response as {
                providerId?: string;
                inboundSamlConfigName?: string;
                spType?: 'firebase' | 'anyobackend';
              };
              this.ssoProviderId = data.providerId || '';
              this.ssoConfigName = data.inboundSamlConfigName || '';
              this.ssoSpType = data.spType || this.ssoSpType;

              const existingSsoMap = this.getSsoDomainMap();
              existingSsoMap[domain] = {
                domain,
                enabled: this.ssoEnabled,
                saml: {
                  sp: {
                    type: this.ssoSpType,
                    providerId: this.ssoProviderId,
                    signRequest: this.ssoSignRequest,
                    gipInboundSamlConfigName: this.ssoConfigName,
                  },
                  idp: {
                    type: this.ssoIdpType,
                    entityId: this.ssoIdpEntityId.trim(),
                    ssoUrl: this.ssoLoginUrl.trim(),
                    certRef: this.ssoCertificate.trim()
                      ? `cert-length:${this.ssoCertificate.trim().length}`
                      : undefined,
                    x509Certificate:
                      this.ssoSpType === 'anyobackend'
                        ? this.ssoCertificate.trim()
                        : undefined,
                  },
                },
              };

              this.partner.ssoDomains = existingSsoMap;
              this.toastService.showSuccess('SAML domain configuration saved');
              this.ssoSaving = false;
            },
            error: (error) => {
              const errorBody = error.error as IAnyoError;
              this.toastService.showAnyoErrorToast(errorBody.description);
              this.ssoSaving = false;
            },
          });
      },
      error: (error) => {
        const errorBody = error.error as IAnyoError;
        this.toastService.showAnyoErrorToast(errorBody.description);
        this.ssoSaving = false;
      },
    });
  }

  calculateSubscriptions() {
    const corporateSubscriptions = this.subscription.corporateSubscriptions;
    this.subscription.corporateSubscriptions = 0;
    this.subscription.familySubscriptions = 0;
    this.subscription.noOfSubscriptions = 0;

    if (this.partner.allowFamilyInvites) {
      const maxFamilyInvites = this.partner.maxFamilyInvitesAllowed!;
      this.subscription.familySubscriptions =
        maxFamilyInvites * corporateSubscriptions;
      this.subscription.noOfSubscriptions =
        corporateSubscriptions + this.subscription.familySubscriptions;
      this.subscription.corporateSubscriptions = corporateSubscriptions;
    } else {
      this.subscription.corporateSubscriptions = corporateSubscriptions;
      this.subscription.noOfSubscriptions = corporateSubscriptions;
    }
  }

  submitAndSubscribe(form: any) {
    this.subscription.partnerId = this.partnerId;
    this.subscription.subscriptionEnd = moment(this.subscription.subscriptionEnd).toISOString();
    const req = this.subscription;
    let flag = true;
    const subscription: Array<any> = Object.values(this.subscription);
    subscription.forEach((field) => {
      if (!field && field != 0) {
        flag = false;
      }
    });
    if (flag) {
      if (this.editMode) {
        if (this.subscriptionId) {
          this.loading = true;
          this.subscriptionService
            .updateSubscription(this.subscriptionId, req)
            .subscribe({
              next: (value) => {
                this.router.navigate(['/partner']);
                this.toastService.showSuccess('Subscription Updated');
                this.loading = false;
              },
              error: (error) => {
                const errorBody = error.error as IAnyoError;
                this.toastService.showAnyoErrorToast(errorBody.description);
                this.loading = false;
              },
            });
        } else {
          this.loading = true;
          this.subscriptionService.createSubscription(req).subscribe({
            next: (value) => {
              this.router.navigate(['/partner']);
              this.toastService.showSuccess('Subscription Created');
              this.loading = false;
            },
            error: (error) => {
              const errorBody = error.error as IAnyoError;
              this.toastService.showAnyoErrorToast(errorBody.description);
              this.loading = false;
            },
          });
        }
      } else {
        this.subscriptionService.createSubscription(req).subscribe({
          next: (value) => {
            this.router.navigate(['/partner']);
            this.toastService.showSuccess('Subscription Created');
          },
          error: (error) => {
            const errorBody = error.error as IAnyoError;
            this.toastService.showAnyoErrorToast(errorBody.description);
          },
        });
      }
    } else {
      this.isSubmit = true;
      this.toastService.showError('Please fill all the required fields');
    }
  }

  redirect(link: string) {
    window.open('http://' + link, '_blank');
  }

  addSpoc() {
    const spocObject = {
      name: '',
      email: '',
      mobile: '',
      isOperations: false,
    };
    this.spoc.push(spocObject);
  }

  spocAuthDelete() {
    this.partnerService.deleteSpoc(this.spocId).subscribe({
      next: () => {
        this.isSpocDelete = false;
        this.isAlert = false;
        this.partner.spocDetails.forEach((spoc: ISpocDetails, index: any) => {
          if (spoc.u_id == this.spocId) {
            this.spoc.splice(index, 1);
          }
        });
      },
      error: (error) => {
        const errorBody = error.error as IAnyoError;
        this.toastService.showAnyoErrorToast(errorBody.description);
      },
    });
  }

  removeSpoc(index: number) {
    if (this.spoc[index].u_id) {
      this.isSpocDelete = true;
      this.isAlert = true;
      this.spocId = this.spoc[index].u_id;
    } else {
      this.spoc.splice(index, 1);
    }
  }

  next(form: any) {
    this.submit(form, true);
  }

  previous() {
    this.gotonext = false;
  }

  openPolicyControls() {
    const objectId = String(this.activatedRoute.snapshot.params['id']);
    this.router.navigate(['/partner', objectId, 'policy-controls']);
  }

  editForm() {
    this.viewForm = false;
    this.editMode = true;
  }

  dialogShow() {
    this.isAlert = !this.isAlert;
  }

  disablePartner() {
    const req = {
      status: Status.Inactive,
    };
    this.partner.status = Status.Inactive;
    const _id = String(this.activatedRoute.snapshot.params['id']);
    this.partnerService.enableAndDisablePartner(_id, req).subscribe({
      next: () => {
        this.router.navigate(['/partner']);
      },
      error: (error) => {
        const errorBody = error.error as IAnyoError;
        this.toastService.showAnyoErrorToast(errorBody.description);
      },
    });
    this.isAlert = false;
    this.isDisabled = true;
  }

  enablePartner() {
    const req = {
      status: Status.Active,
    };
    this.partner.status = Status.Active;
    const _id = String(this.activatedRoute.snapshot.params['id']);
    this.partnerService.enableAndDisablePartner(_id, req).subscribe({
      next: () => {
        this.router.navigate(['/partner']);
      },
      error: (error) => {
        const errorBody = error.error as IAnyoError;
        this.toastService.showAnyoErrorToast(errorBody.description);
      },
    });
    this.isAlert = false;
    this.isDisabled = false;
  }


  fetchSubscription(form?: any) {
    this.gotonext = true;
    if (form) {
      this.submit(form);
    }
    this.subscriptionService.getSubscription(this.partnerId).subscribe({
      next: (value: any) => {
        this.subscription = value;
        this.subscriptionId = value.id;
        this.subscription.subscriptionStart = new Date(value.subscriptionStart);
        this.subscription.subscriptionEnd = new Date(value.subscriptionEnd);
        this.calculateSubscriptions();
      },
      error: (error) => {
        console.log(error);
        // const errorBody = error.error as IAnyoError;
        // this.toastService.showAnyoErrorToast(errorBody.description);
      },
    });
  }

  populate(_id: string) {
    this.partnerService.getPartner(_id).subscribe({
      next: (value: any) => {
        this.viewForm = true;
        this.showDisable = true;
        this.partner = value;
        this.spoc = value.spocDetails;
        this.partnerId = value.partnerId;
        if (value.status == Status.Inactive) {
          this.isDisabled = true;
        }
        this.allowFamilyInvites = value.allowFamilyInvites;
        this.maxFamilyInvitesAllowed = value.maxFamilyInvitesAllowed;
        this.archived = value.archived;
        if (value.whitelistedDomains) {
          this.whitelistedDomains = value.whitelistedDomains?.map(
            (data: string) => {
              return { domain: data };
            },
          );
        }
        this.partnerDashboardId = value.partnerPortalDashboardId;
        this.partnerDashboardUrl = value.partnerPortalDashboardUrl;
        this.isDOB = value.dataCollection.dob;
        this.isEmail = value.dataCollection.email;
        this.isPhoneNumber = value.dataCollection.phoneNumber;
        this.isGender = value.dataCollection.gender;
        this.isName = value.dataCollection.name;
        this.companyMetaConfigForms = (value.companyMetaConfig || [])
          .sort((a: CompanyMetaConfigField, b: CompanyMetaConfigField) => a.order - b.order)
          .map((field: CompanyMetaConfigField) => ({
            ...field,
            appliesTo: field.appliesTo || CompanyMetaAppliesTo.CORPORATE,
            enabled: field.enabled !== false,
            order: Number.isFinite(Number(field.order)) ? Number(field.order) : 0,
            optionsInput: (field.options || []).join(', '),
          }));
        
        this.partner.isTesting = value.userTags.includes(UserTags.TESTING);
        this.partner.allowMarketingEmailNotifications =
          value.allowMarketingEmailNotifications !== false;
        this.partner.restrictUserPostReplies =
          !!value.restrictUserPostReplies;

        const ssoDomains = this.getSsoDomainKeys(value.ssoDomains);
        this.ssoDomain = this.getWhitelistedDomainsForSso()[0] || ssoDomains[0] || '';
        this.hydrateSsoFormFromPartner(this.ssoDomain);
      },
      error: (error) => {
        const errorBody = error.error as IAnyoError;
        this.toastService.showAnyoErrorToast(errorBody.description);
      },
    });
  }

  async loadMasterData() {
    this.masterdataService.masterDataList().subscribe({
      next: (masterData) => {
        if (masterData.partnerSectors) {
          masterData.partnerSectors.forEach((data) => {
            if (data.status == Status.Active) {
              this.partnerSector.push(data.data);
            }
          });
        }
        if (masterData.partnerType) {
          masterData.partnerType.forEach((data) => {
            if (data.status == Status.Active) {
              this.partnerType.push(data.data);
            }
          });
        }
        if (masterData.noOfSubscriptions) {
          masterData.noOfSubscriptions.forEach((data) => {
            if (data.status == Status.Active) {
              this.noOfSubscriptions.push(data.data);
            }
          });
        }
      },
      error: (error) => {
        const errorBody = error.error as IAnyoError;
        this.toastService.showAnyoErrorToast(errorBody.description);
      },
    });
  }

  formatSubscriptionEndDate(date: string){
    return moment(date, 'DD / MM / YYYY').toDate();
  }

  async ngOnInit(): Promise<void> {
    this.auth.currentAuthStatus.subscribe(async (user) => {
      if (user) {
        await this.loadMasterData();
        if (this.activatedRoute.snapshot.params) {
          const value = this.activatedRoute.snapshot.params['id'];
          if (value) {
            this.populate(value);
          }
        }
      }
    });
  }

  private getSsoDomainMap(
    domains = this.partner.ssoDomains,
  ): Record<string, IPartnerSsoDomain> {
    return domains || {};
  }

  private getSsoDomainEntry(domain: string): IPartnerSsoDomain | undefined {
    const map = this.getSsoDomainMap();
    return map[domain.toLowerCase()];
  }

  private getSsoDomainKeys(
    domains = this.partner.ssoDomains,
  ): string[] {
    return Object.keys(this.getSsoDomainMap(domains));
  }
}
